var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _path11, _path12, _path13, _g3, _path14, _g4, _path15, _path16, _g5, _path17, _path18, _g6, _path19, _path20, _g7, _path21, _path22, _g8, _path23, _path24, _g9, _path25, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOsmo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2395 5.89922C28.9214 4.67418 27.8989 3.44915 26.0584 2.08543C24.5814 0.999075 23.0136 0.375 21.7638 0.375C21.5138 0.375 21.2866 0.398113 21.0594 0.44434C20.4913 0.55991 19.9914 0.97596 19.6733 1.60004C19.287 2.33968 19.1961 3.33358 19.4461 3.93454C19.537 4.11945 19.6506 4.35059 19.7869 4.55861C18.5826 5.29826 17.9009 5.50629 17.8101 5.5294C20.9458 6.59263 23.5589 8.81158 25.195 11.7008L25.2177 11.4234C25.2858 10.6607 25.513 9.78235 25.8311 8.88092C26.1492 8.97337 26.4674 9.01959 26.7855 9.01959C27.6263 9.01959 28.3533 8.67291 28.8078 8.04882C29.2623 7.42474 29.444 6.59264 29.2395 5.89922Z",
    fill: "#5E12A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9676 8.21047C28.0354 8.78827 28.8761 7.1703 28.6034 6.08396C28.308 4.99761 27.3537 3.88814 25.6722 2.63999C23.9907 1.39184 22.2866 0.883339 21.1959 1.11447C20.1052 1.34561 19.787 3.03293 20.0597 3.68012C20.1733 3.93437 20.4233 4.30419 20.7641 4.72024C20.3324 5.02072 19.9233 5.25186 19.5825 5.45989C21.673 6.40756 23.4909 7.88684 24.8542 9.73593C25.0132 9.1119 25.2405 8.55715 25.445 8.07174C25.604 8.09485 25.7858 8.14107 25.9676 8.21047Z",
    fill: "url(#paint0_radial_2542_4077)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1285 30.8621C21.1436 30.8621 26.8304 25.0773 26.8304 17.9414C26.8304 10.8056 21.1436 5.02075 14.1285 5.02075C7.11338 5.02075 1.42651 10.8056 1.42651 17.9414C1.42651 25.0773 7.11338 30.8621 14.1285 30.8621Z",
    fill: "url(#paint1_radial_2542_4077)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.558 5.02077C25.8311 3.17166 24.3768 2.68627 22.6272 2.29333C21.2638 1.96974 21.6274 1.18387 23.2861 1.34566C22.4908 1.06829 21.741 0.998953 21.1957 1.11452C20.105 1.34566 19.7868 3.03297 20.0595 3.68017C20.1731 3.93442 20.4231 4.30424 20.7639 4.72029C20.1504 5.13634 19.6278 5.43682 19.196 5.66796C19.4005 5.76041 19.6505 5.87599 19.9459 6.03778C20.7184 6.45383 21.5592 7.14722 21.5592 7.14722C20.2867 6.03778 20.5594 5.52927 22.3091 4.28112C22.8544 3.88819 23.8542 3.93442 24.7858 4.41981C25.7175 4.9052 26.8082 6.13024 26.8082 6.13024L25.7629 8.16428C25.8311 8.18739 25.8992 8.2105 25.9674 8.23362C26.6264 8.41851 27.149 8.37229 27.558 8.2105C28.0352 7.90998 29.2849 6.89299 27.558 5.02077Z",
    fill: "#A98698"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6042 3.40273C23.0587 3.58765 23.6495 3.91124 24.3766 4.39663C25.2401 4.97448 25.9899 5.62167 26.4671 6.13017C25.6718 7.19339 25.1491 8.64957 24.831 9.66663C24.9901 9.89775 25.1719 10.1289 25.331 10.36C25.49 9.78219 25.7627 8.92698 26.1262 8.07171C26.2171 8.09489 26.3307 8.09489 26.4444 8.09489C26.717 8.09489 27.0351 8.0486 27.2851 7.84059C27.4668 7.70192 27.6714 7.44769 27.6487 6.98538C27.6487 6.54623 27.3078 5.9915 26.6034 5.32119C26.1035 4.8358 25.4219 4.30418 24.7401 3.81879C22.786 2.5013 21.4226 2.13147 20.8092 2.75555C20.4001 3.17159 20.4456 3.6801 20.5819 4.04993C19.8548 4.53532 19.2413 4.88202 18.8323 5.11316C19.1049 5.20562 19.3549 5.32119 19.6276 5.43676C20.3547 5.04383 21.3999 4.37352 22.6042 3.40273ZM26.8988 6.70803C26.967 6.82359 26.9897 6.93916 26.9897 7.00849C26.9897 7.2165 26.9215 7.2859 26.8761 7.33213C26.7852 7.40146 26.6034 7.44769 26.4444 7.44769C26.5807 7.17028 26.7398 6.93916 26.8988 6.70803ZM21.2863 3.26406C21.3545 3.19471 21.5362 3.14848 21.8317 3.19471C21.6044 3.37962 21.3772 3.54142 21.15 3.70322C21.1273 3.54142 21.15 3.37962 21.2863 3.26406Z",
    fill: "#5E12A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1288 4.25806C6.6985 4.25806 0.677002 10.3832 0.677002 17.9415C0.677002 25.4997 6.6985 31.6249 14.1288 31.6249C21.5592 31.6249 27.5806 25.4997 27.5806 17.9415C27.5806 10.3832 21.5364 4.25806 14.1288 4.25806ZM14.1288 30.8622C7.10751 30.8622 1.42685 25.0837 1.42685 17.9415C1.42685 10.7993 7.10751 5.02081 14.1288 5.02081C21.1501 5.02081 26.8308 10.7993 26.8308 17.9415C26.8308 25.0837 21.1274 30.8622 14.1288 30.8622Z",
    fill: "#5E12A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.1285 30.8623C21.1436 30.8623 26.8304 25.0775 26.8304 17.9417C26.8304 10.8058 21.1436 5.021 14.1285 5.021C7.11338 5.021 1.42651 10.8058 1.42651 17.9417C1.42651 25.0775 7.11338 30.8623 14.1285 30.8623Z",
    fill: "url(#paint2_linear_2542_4077)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.038 29.2905C7.10761 28.1579 2.40402 21.5243 3.54015 14.4745C4.04005 11.3542 5.58519 8.69603 7.76657 6.77759C4.58539 8.64981 2.22224 11.9089 1.586 15.8844C0.472593 22.9342 5.17618 29.5679 12.0839 30.7004C15.9467 31.3476 19.6733 30.1226 22.4227 27.7187C19.9914 29.1518 17.0374 29.7759 14.038 29.2905Z",
    fill: "#A98698"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.1513 5.20592C12.9474 4.6743 9.83449 5.41395 7.2895 7.05505C7.24406 7.10128 7.19862 7.1475 7.19862 7.1475C8.1757 6.54653 9.60721 6.01492 9.60721 6.01492C5.92617 8.1876 4.79004 10.6608 4.79004 10.6608C6.22157 7.84092 10.4252 5.85311 13.72 5.71443C17.0148 5.57575 19.1735 6.56965 21.8093 8.71924C24.4452 10.892 26.0357 15.3298 25.8767 18.8431C25.7403 22.3564 23.9225 25.1994 23.9225 25.1994C25.1722 23.5584 25.9221 22.3564 26.3993 21.1314C26.4901 20.7616 26.5811 20.3918 26.6265 19.9988C27.7627 12.9722 23.0817 6.33851 16.1513 5.20592Z",
    fill: "url(#paint3_linear_2542_4077)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1942 17.8259C26.1942 24.5983 20.7862 30.0994 14.1285 30.0994C7.47075 30.0994 2.04004 24.5983 2.04004 17.8259H26.1942Z",
    fill: "url(#paint4_linear_2542_4077)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.2404 17.8259C25.2404 24.4365 20.1051 29.8451 13.6519 30.0994C13.8109 30.0994 13.97 30.0994 14.129 30.0994C20.7867 30.0994 26.1948 24.5983 26.1948 17.8259H25.2404Z",
    fill: "url(#paint5_linear_2542_4077)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M3.74424 17.8259H2.04004C2.04004 24.5983 7.44803 30.0994 14.1058 30.0994C14.4012 30.0994 14.6738 30.0994 14.9465 30.0763C8.69777 29.614 3.74424 24.2978 3.74424 17.8259Z",
    fill: "url(#paint6_linear_2542_4077)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1715 17.9415C26.1715 16.5316 23.7629 15.7226 20.559 15.4452C18.2413 15.2603 15.9008 15.4915 13.2196 16.3236C10.9019 17.017 8.81138 16.9014 7.28898 16.7165C3.90329 16.3236 2.04004 16.2773 2.04004 17.9415C2.04004 20.3454 6.85724 23.3502 14.0831 22.3101C17.7414 21.7784 19.6274 20.6921 21.786 19.9525C24.1265 19.1666 26.1715 19.1897 26.1715 17.9415Z",
    fill: "url(#paint7_linear_2542_4077)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0826 12.1168C19.2121 12.1168 20.1277 11.1855 20.1277 10.0366C20.1277 8.88768 19.2121 7.9563 18.0826 7.9563C16.9532 7.9563 16.0376 8.88768 16.0376 10.0366C16.0376 11.1855 16.9532 12.1168 18.0826 12.1168Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4226 13.6653C21.8994 13.6653 22.286 13.2721 22.286 12.787C22.286 12.3019 21.8994 11.9087 21.4226 11.9087C20.9457 11.9087 20.5591 12.3019 20.5591 12.787C20.5591 13.2721 20.9457 13.6653 21.4226 13.6653Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.513 8.37242C24.4903 8.37242 24.4676 8.37242 24.4676 8.37242C24.3312 8.34931 24.2403 8.21064 24.263 8.04879C24.4676 6.98557 25.331 5.96855 25.3764 5.92233C25.4674 5.80676 25.6491 5.80676 25.74 5.89922C25.8536 5.99167 25.8536 6.17658 25.7627 6.26903C25.74 6.29215 24.9447 7.2398 24.7629 8.16435C24.7402 8.30308 24.6266 8.37242 24.513 8.37242Z",
    fill: "url(#paint8_linear_2542_4077)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.2896 27.58C13.641 27.58 13.9258 27.2903 13.9258 26.9328C13.9258 26.5754 13.641 26.2856 13.2896 26.2856C12.9382 26.2856 12.6533 26.5754 12.6533 26.9328C12.6533 27.2903 12.9382 27.58 13.2896 27.58Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.9246 27.3497C12.6746 27.0954 12.6746 26.6794 12.9246 26.4252C12.97 26.379 13.0155 26.3559 13.0609 26.3096C12.97 26.3327 12.9019 26.379 12.8337 26.4483C12.5838 26.7025 12.5838 27.1186 12.8337 27.3729C13.0382 27.5809 13.3563 27.6271 13.6063 27.4884C13.379 27.5809 13.1063 27.5346 12.9246 27.3497Z",
    fill: "url(#paint9_linear_2542_4077)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.515 26.748C13.5903 26.748 13.6513 26.686 13.6513 26.6094C13.6513 26.5328 13.5903 26.4707 13.515 26.4707C13.4397 26.4707 13.3787 26.5328 13.3787 26.6094C13.3787 26.686 13.4397 26.748 13.515 26.748Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.6072 27.2565C16.9586 27.2565 17.2434 26.9668 17.2434 26.6093C17.2434 26.2519 16.9586 25.9622 16.6072 25.9622C16.2558 25.9622 15.9709 26.2519 15.9709 26.6093C15.9709 26.9668 16.2558 27.2565 16.6072 27.2565Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.242 27.0257C15.992 26.7715 15.992 26.3554 16.242 26.1012C16.2874 26.0549 16.3328 26.0318 16.3783 25.9856C16.2874 26.0087 16.2192 26.0549 16.1511 26.1243C15.9011 26.3785 15.9011 26.7946 16.1511 27.0488C16.3556 27.2569 16.6737 27.3031 16.9237 27.1644C16.6964 27.2569 16.4237 27.2106 16.242 27.0257Z",
    fill: "url(#paint10_linear_2542_4077)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.8324 26.4244C16.9076 26.4244 16.9687 26.3623 16.9687 26.2857C16.9687 26.2091 16.9076 26.147 16.8324 26.147C16.757 26.147 16.696 26.2091 16.696 26.2857C16.696 26.3623 16.757 26.4244 16.8324 26.4244Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.9698 28.7589C15.2334 28.7589 15.447 28.5416 15.447 28.2735C15.447 28.0054 15.2334 27.7881 14.9698 27.7881C14.7063 27.7881 14.4927 28.0054 14.4927 28.2735C14.4927 28.5416 14.7063 28.7589 14.9698 28.7589Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.6972 28.5745C14.5154 28.3896 14.5154 28.066 14.6972 27.8811C14.7199 27.858 14.7653 27.8349 14.7881 27.8118C14.7199 27.8349 14.6744 27.8811 14.629 27.9273C14.4472 28.1122 14.4472 28.4358 14.629 28.6208C14.7881 28.7825 15.0153 28.8056 15.2198 28.6901C15.038 28.7594 14.8335 28.7132 14.6972 28.5745Z",
    fill: "url(#paint11_linear_2542_4077)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.129 28.1117C15.1792 28.1117 15.2199 28.0703 15.2199 28.0192C15.2199 27.9682 15.1792 27.9268 15.129 27.9268C15.0788 27.9268 15.0381 27.9682 15.0381 28.0192C15.0381 28.0703 15.0788 28.1117 15.129 28.1117Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.9007 28.412C18.1643 28.412 18.3779 28.1947 18.3779 27.9266C18.3779 27.6585 18.1643 27.4412 17.9007 27.4412C17.6372 27.4412 17.4236 27.6585 17.4236 27.9266C17.4236 28.1947 17.6372 28.412 17.9007 28.412Z",
    fill: "white"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.6281 28.2278C17.4463 28.0429 17.4463 27.7193 17.6281 27.5344C17.6508 27.5113 17.6962 27.4882 17.719 27.4651C17.6508 27.4882 17.6054 27.5344 17.5599 27.5806C17.3781 27.7655 17.3781 28.0891 17.5599 28.2741C17.719 28.4359 17.9462 28.459 18.1507 28.3434C17.9689 28.4127 17.7644 28.3665 17.6281 28.2278Z",
    fill: "url(#paint12_linear_2542_4077)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.0599 27.7647C18.1101 27.7647 18.1508 27.7234 18.1508 27.6723C18.1508 27.6212 18.1101 27.5798 18.0599 27.5798C18.0097 27.5798 17.969 27.6212 17.969 27.6723C17.969 27.7234 18.0097 27.7647 18.0599 27.7647Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.5838 27.3489C11.161 27.3489 11.629 26.8729 11.629 26.2857C11.629 25.6985 11.161 25.2224 10.5838 25.2224C10.0065 25.2224 9.53857 25.6985 9.53857 26.2857C9.53857 26.8729 10.0065 27.3489 10.5838 27.3489Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.99385 26.9559C9.58486 26.5399 9.58486 25.8695 9.99385 25.4535C10.062 25.3842 10.1302 25.338 10.2211 25.2917C10.0847 25.338 9.97113 25.4304 9.85752 25.5229C9.44854 25.9389 9.44854 26.6092 9.85752 27.0253C10.1983 27.372 10.721 27.4413 11.13 27.1871C10.7437 27.3488 10.2892 27.2795 9.99385 26.9559Z",
    fill: "url(#paint13_linear_2542_4077)"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.9477 25.9623C11.0731 25.9623 11.1749 25.8588 11.1749 25.7311C11.1749 25.6035 11.0731 25.5 10.9477 25.5C10.8222 25.5 10.7205 25.6035 10.7205 25.7311C10.7205 25.8588 10.8222 25.9623 10.9477 25.9623Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.9234 24.7371C20.5006 24.7371 20.9686 24.261 20.9686 23.6738C20.9686 23.0866 20.5006 22.6106 19.9234 22.6106C19.3461 22.6106 18.8782 23.0866 18.8782 23.6738C18.8782 24.261 19.3461 24.7371 19.9234 24.7371Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.3098 24.3441C18.9008 23.928 18.9008 23.2577 19.3098 22.8417C19.378 22.7724 19.4461 22.7262 19.537 22.6799C19.4007 22.7262 19.2871 22.8186 19.1735 22.9111C18.7644 23.3271 18.7644 23.9974 19.1735 24.4135C19.5143 24.7601 20.0369 24.8295 20.4459 24.5752C20.0596 24.737 19.6279 24.6677 19.3098 24.3441Z",
    fill: "url(#paint14_linear_2542_4077)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.2868 23.3502C20.4123 23.3502 20.5141 23.2467 20.5141 23.1191C20.5141 22.9914 20.4123 22.8879 20.2868 22.8879C20.1613 22.8879 20.0596 22.9914 20.0596 23.1191C20.0596 23.2467 20.1613 23.3502 20.2868 23.3502Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2542_4077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.189 4.62777) scale(10.1557 10.3306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2542_4077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5383 9.03368) scale(24.8474 25.2753)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    stopColor: "#A087C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10002F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2542_4077",
    x1: 12.091,
    y1: 30.679,
    x2: 16.2911,
    y2: 5.20551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2542_4077",
    x1: 23.0807,
    y1: 9.16683,
    x2: 12.4137,
    y2: 18.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2542_4077",
    x1: 2.05026,
    y1: 23.9555,
    x2: 26.1884,
    y2: 23.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0002E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#FF00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2542_4077",
    x1: 27.3315,
    y1: 18.9029,
    x2: 13.9819,
    y2: 31.3055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2542_4077",
    x1: 2.05026,
    y1: 23.9555,
    x2: 14.964,
    y2: 23.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#7D00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2542_4077",
    x1: 2.06646,
    y1: 18.9612,
    x2: 26.1722,
    y2: 18.9612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#BE00C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2542_4077",
    x1: 25.7769,
    y1: 5.80976,
    x2: 24.0012,
    y2: 8.64651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2542_4077",
    x1: 12.6456,
    y1: 26.9535,
    x2: 13.6069,
    y2: 26.9535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2542_4077",
    x1: 15.9606,
    y1: 26.6251,
    x2: 16.922,
    y2: 26.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2542_4077",
    x1: 14.4897,
    y1: 28.2795,
    x2: 15.2114,
    y2: 28.2795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2542_4077",
    x1: 17.4108,
    y1: 27.9319,
    x2: 18.1325,
    y2: 27.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2542_4077",
    x1: 9.54033,
    y1: 26.3127,
    x2: 11.1103,
    y2: 26.3127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2542_4077",
    x1: 18.865,
    y1: 23.7001,
    x2: 20.435,
    y2: 23.7001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsmo);
export default __webpack_public_path__ + "static/media/osmo.e890361ca770d9aa84b74dcbf29e1245.svg";
export { ForwardRef as ReactComponent };